// MUST be the first import of src/main.js. ES modules evaluate in import order, depth first, so the
// body below runs before the code of every module imported after it: before PostHog, Amplify (it
// keeps its session in localStorage), the logger, the queues, i18n and the service worker can write
// a single key. Once any of them has, the storage is no longer empty and a fresh install would be
// recorded as a legacy one (see src/installOrigin.js). Keep this file free of imports besides that one.
import { markInstallOrigin } from './installOrigin';

try {
  markInstallOrigin(window.localStorage);
} catch (_) { /* storage blocked: nothing to record, and nothing offered */ }
